import {Component, OnInit} from '@angular/core';
import {BaseComponent} from "../common/base-component";
import {BankAccountService} from "./bank-account-service";
import {BankAccountOwnerEditComponent} from "./bank-account-owner-edit";
import {ModalService} from "./../services/modal-service";
import {MessageService} from "../services/message-service";

@Component({
    selector: 'dk-bank-account-owners',
    template: require('./bank-account-owners.html'),
    //directives: [BankAccountOwnerEditComponent],
    providers: [BankAccountService]
})

export class BankAccountOwnersComponent extends BaseComponent implements OnInit {
    public owners:any[];

    public isInEdit:boolean = false;
    public editedId:number = null;

    constructor(private bankAccountService:BankAccountService,
                private modalService: ModalService,
                private messageService: MessageService) {
        super();
    }

    load() {
        this.bankAccountService.owners().subscribe(owners => {
            this.owners = owners;
        });
    }

    ngOnInit():void {
        this.load();
    }

    cancel() {
        this.isInEdit = false;
        this.load();
    }

    edit(id:number):void {
        this.isInEdit = false;
        this.editedId = id;
        this.isInEdit = true;
    }

    delete(id:number):void {
        this.modalService.confirm().then(result => {
            if (result) {
                this.bankAccountService.deleteOwner(id).subscribe(() => {
                    this.messageService.deleted();
                    this.load();
                }, error => {
                    this.messageService.errorByMessageId(error.messageId);
                });
            }
        })
    }
}
